import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { IdValueObject } from '../../../../utility/model/id-value-object.model';

export class PostId extends IdValueObject {
  static create(value: string): PostId {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new PostId(value);
  }
}
